import {
    CREATE_TENANCY_CUSTOMIZATION_FAILURE,
    CREATE_TENANCY_CUSTOMIZATION_REQUEST,
    CREATE_TENANCY_CUSTOMIZATION_SUCCESS,
    DELETE_TENANCY_CUSTOMIZATION_FAILURE,
    DELETE_TENANCY_CUSTOMIZATION_REQUEST,
    DELETE_TENANCY_CUSTOMIZATION_SUCCESS,
    GET_TENANCY_CUSTOMIZATION_FAILURE,
    GET_TENANCY_CUSTOMIZATION_REQUEST,
    GET_TENANCY_CUSTOMIZATION_SUCCESS,
    REFRESH_TENANCY_CUSTOMIZATION_REQUEST,
    SET_CUSTOMIZATION_DATA,
    UPDATE_TENANCY_CUSTOMIZATION_FAILURE,
    UPDATE_TENANCY_CUSTOMIZATION_REQUEST,
    UPDATE_TENANCY_CUSTOMIZATION_SUCCESS,
} from "./actions";
import { DEFAULT_CUSTOMIZATION } from "./constants";

// Initial State
/** @type {{ getCustomizationResult: IResultState, customizationData: ICustomizationData, createCustomizationResult: IResultState, updateCustomizationResult: IResultState, deleteCustomizationResult: IResultState, selectedCustomization: null, loading: boolean }} */
const initialState = {
    getCustomizationResult: { success: null },
    customizationData: DEFAULT_CUSTOMIZATION, // Pre-populate the defaults in case there isn't any customisation saved
    createCustomizationResult: { success: null },
    updateCustomizationResult: { success: null },
    deleteCustomizationResult: { success: null },
    selectedCustomization: null, // Holds data for a single customization when necessary
    loading: false,
};

// Reducer function
export default (state = initialState, action) => {
    switch (action.type) {
        // Loading states for each operation
        case GET_TENANCY_CUSTOMIZATION_REQUEST:
            return { ...state, getCustomizationResult: { success: null, inProgress: true }, loading: true };
        case REFRESH_TENANCY_CUSTOMIZATION_REQUEST:
            return { ...state, getCustomizationResult: { success: null, inProgress: true } };
        case CREATE_TENANCY_CUSTOMIZATION_REQUEST:
            return { ...state, createCustomizationResult: { success: null, inProgress: true } };
        case UPDATE_TENANCY_CUSTOMIZATION_REQUEST:
            return { ...state, updateCustomizationResult: { success: null, inProgress: true } };
        case DELETE_TENANCY_CUSTOMIZATION_REQUEST:
            return { ...state, deleteCustomizationResult: { success: null, inProgress: true } };

        // Success cases for each operation
        case GET_TENANCY_CUSTOMIZATION_SUCCESS:
            return {
                ...state,
                getCustomizationResult: { success: true },
                customizationData: action.payload.customizationData,
                loading: false,
            };

        case CREATE_TENANCY_CUSTOMIZATION_SUCCESS:
            return {
                ...state,
                createCustomizationResult: { success: true },
                // Merge with defaults so a partial API response never leaves color fields undefined
                customizationData: { ...DEFAULT_CUSTOMIZATION, ...action.payload.customizationData },
                loading: false,
            };

        case UPDATE_TENANCY_CUSTOMIZATION_SUCCESS:
            return {
                ...state,
                updateCustomizationResult: { success: true },
                // Merge with existing data so a partial API response never leaves color fields undefined
                customizationData: { ...state.customizationData, ...action.payload.customizationData },
                loading: false,
            };

        case DELETE_TENANCY_CUSTOMIZATION_SUCCESS:
            return {
                ...state,
                deleteCustomizationResult: { success: true },
                customizationData: null, // Nothing saved in DB; ThemeCustomizer falls back to DEFAULT_CUSTOMIZATION for display
                loading: false,
            };

        // Failure cases for each operation
        case GET_TENANCY_CUSTOMIZATION_FAILURE:
            return {
                ...state,
                getCustomizationResult: { success: false, ...action.payload.error },
                customizationData: state.customizationData ?? DEFAULT_CUSTOMIZATION, // keep existing if we had cached data, else fall back
                loading: false,
            };

        case CREATE_TENANCY_CUSTOMIZATION_FAILURE:
            return {
                ...state,
                createCustomizationResult: { success: false, ...action.payload.error },
                loading: false,
            };

        case UPDATE_TENANCY_CUSTOMIZATION_FAILURE:
            return {
                ...state,
                updateCustomizationResult: { success: false, ...action.payload.error },
                loading: false,
            };

        case DELETE_TENANCY_CUSTOMIZATION_FAILURE:
            return {
                ...state,
                deleteCustomizationResult: { success: false, ...action.payload.error },
                loading: false,
            };

        // This case is for Storybook testing, no impact on production
        case SET_CUSTOMIZATION_DATA:
            return {
                ...state,
                customizationData: action.payload.customizationData,
                loading: false,
            };

        // Default case: return the current state if no action matches
        default:
            return state;
    }
};
